import { css } from 'styled-components';
import { darken } from 'polished';
/**
 * getAppearance
 *
 * Helper function to render the right css
 * compared to the appearance given to it.
 *
 * @param {object} palette // The color's pallete of the theme.
 * @param {string} appearance // The button appearance.
 */

export var getAppearance = function getAppearance(_ref, appearance) {
  var palette = _ref.palette;
  return {
    "default": css(["color:", ";background:none;"], palette.darkBlue),
    primary: css(["background:", " linear-gradient( 0deg,", " 0%,", " 100% );border:1px solid ", ";box-shadow:inset 0 0.2rem 0 0 ", ";&:hover:not([disabled]):not(:active){background:", ";box-shadow:none;}&:active{background-color:", ";border:1px solid ", ";box-shadow:inset 0 0 0 0.1rem ", ";}"], palette.primary["default"], function (_ref2) {
      var palette = _ref2.theme.palette;
      return palette.whiteOpacity(0);
    }, function (_ref3) {
      var palette = _ref3.theme.palette;
      return palette.whiteOpacity(0.1);
    }, palette.primary.dark, palette.whiteOpacity(0.1), palette.primary["default"], palette.primary.dark, palette.primary.darker, palette.primary.darker),
    secondary: css(["color:", ";background:linear-gradient(180deg,", " 0%,", " 100%);border:1px solid ", ";"], palette.spaceGrey, palette.white, palette.paleGrey, palette.lightGrey),
    success: css(["background:", " linear-gradient(0deg,", " 0%,", " 100%);border:1px solid ", ";box-shadow:inset 0 0.2rem 0 0 ", ";&:hover:not([disabled]):not(:active){background:", ";box-shadow:none;}&:active{background-color:", ";border:1px solid ", ";box-shadow:inset 0 0 0 0.1rem ", ";}"], palette.success["default"], palette.whiteOpacity(0), palette.whiteOpacity(0.1), palette.success.dark, palette.whiteOpacity(0.1), palette.success["default"], palette.success.dark, palette.success.darker, palette.success.darker),
    failure: css(["background:", " linear-gradient(0deg,", " 0%,", " 100%);border:1px solid ", ";box-shadow:inset 0 0.2rem 0 0 ", ";&:hover:not([disabled]):not(:active){background:", ";box-shadow:none;}&:active{background-color:", ";border:1px solid ", ";box-shadow:inset 0 0 0 0.1rem ", ";}"], palette.failure["default"], palette.whiteOpacity(0), palette.whiteOpacity(0.1), palette.failure.dark, palette.whiteOpacity(0.1), palette.failure["default"], palette.failure.dark, palette.failure.darker, palette.failure.darker),
    google: css(["background:", ";border:0.1rem solid ", ";box-shadow:inset 0 0.2rem 0 0 ", ";&:hover:not([disabled]):not(:active){background:", ";}"], palette.googleBrandRed, palette.googleBrandRed, palette.whiteOpacity(0.1), darken(0.1, palette.googleBrandRed))
  }[appearance];
};
/**
 * getSize
 *
 * Helper function to render the right css
 * compared to the size given to him.
 *
 * @param {object} fonts // The font theme.
 * @param {string} size // The button size.
 */

export var getSize = function getSize(_ref4, size, icon) {
  var fonts = _ref4.fonts;
  return {
    small: css(["padding:", ";"], !icon ? '0.35rem 1.4rem' : '0.35rem 1.3rem'),
    "default": css(["padding:", ";"], !icon ? '0.75rem 1.6rem' : '0.75rem 1.4rem'),
    large: css(["padding:", ";font-size:", ";line-height:1.5;"], !icon ? '0.7rem 2rem' : '0.7rem 1.8rem', fonts.size.big)
  }[size];
};